<template>
  <div class="_touch">
    <canvas id="canvas" ref="box" @mouseup="touchEnd" @mousedown="touchStart" @mousemove="touchMove"
            @touchstart="touchStart"
            @touchmove="touchMove"></canvas>
  </div>
</template>

<script>
export default {
  name: 'CircleRange',
  data () {
    return {
      angle: 0,
      level: 1,
      stop: true,
      windowWitdh: 0,
      windowHeight: 0,
      light: false,
      ctx: null,
      app: null,
      temperature: 16
    }
  },
  props: {
    tt: {
      default: 16
    }
  },
  mounted () {
    this.temperature = this.tt
    this.app = document.getElementById('canvas')
    this.ctx = this.app.getContext('2d')
    window.onresize = this.resizeDraw
    this.resizeDraw()
  },
  methods: {
    touchStart (e) {
      e.preventDefault()
      e.stopPropagation()
      let roundBox = this.$refs.box
      var w = roundBox.offsetWidth / 2
      var h = roundBox.offsetHeight / 2
      this.px = roundBox.getBoundingClientRect().left + w
      this.py = roundBox.getBoundingClientRect().top + h
      this.stop = false
    },
    touchMove (e) {
      if (this.stop) {
        return
      }
      e.preventDefault()
      e.stopPropagation()
      if (e.touches) {
        this.getAngle(e.changedTouches[0].clientX, e.changedTouches[0].clientY)
      } else {
        this.getAngle(e.clientX, e.clientY)
      }
    },
    touchEnd (e) {
      this.stop = true
      e.preventDefault()
      e.stopPropagation()
    },
    resetAngle (angle) {
      let list = []
      for (let i = 0; i < 15; i++) {
        list.push({ angle: 45 + (i * (270 / 14)), level: i + 16 })
      }
      let result = list.filter(function (currentVal, index, arr) {
        return Math.abs(angle - currentVal.angle) <= 18
      })
      this.angle = (result[0] && result[0].angle) || angle
      let angleConvert = 0
      if (this.angle > 225) {
        angleConvert = this.angle - 180
      } else if (this.angle < 180) {
        angleConvert = this.angle + 180
      }
      this.draw(angleConvert + 90)
      const tt = parseInt(16 + (angleConvert + 90 - 135) / (270 / 71 * 5))
      this.$emit('change', tt > 30 ? 30 : tt < 16 ? 16 : tt)
    },
    getAngle (mx, my) {
      var px = this.px
      var py = this.py
      var x = Math.abs(px - mx)
      var y = Math.abs(py - my)
      var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2))
      var cos = y / z
      var radina = Math.acos(cos) // 用反三角函数求弧度
      var angle = Math.floor(180 / (Math.PI / radina)) // 将弧度转换成角度
      if (mx > px && my > py) {
        // 鼠标在第四象限
        angle = 180 - angle
      }
      if (mx === px && my > py) {
        // 鼠标在y轴负方向上
        angle = 180
      }
      if (mx > px && my === py) {
        // 鼠标在x轴正方向上
        angle = 90
      }
      if (mx < px && my > py) {
        // 鼠标在第三象限
        angle = 180 + angle
      }
      if (mx < px && my === py) {
        // 鼠标在x轴负方向
        angle = 270
      }
      if (mx < px && my < py) {
        // 鼠标在第二象限
        angle = 360 - angle
      }
      this.angle = angle
      this.$nextTick(function () {
        this.resetAngle(this.angle)
      })
    },
    resizeDraw () {
      this.windowWitdh = 700
      this.windowHeight = 700
      this.app.width = this.windowWitdh
      this.app.height = this.windowHeight
      this.ctx.restore()
      this.ctx.translate(this.windowWitdh / 2, this.windowHeight / 2)
      this.draw((this.temperature - 16) * ((270 / 71) * 5) + 135)
    },
    point (radius, angle) {
      return {
        x: radius * Math.cos(angle * Math.PI / 180),
        y: radius * Math.sin(angle * Math.PI / 180)
      }
    },
    draw (speed) {
      // 清除背景
      this.ctx.fillStyle = '#fff'
      this.ctx.beginPath()
      // 起點/長/寬
      this.ctx.rect(-2000, -2000, 4000, 4000)
      this.ctx.fill()

      // coordinate = () => {
      //   this.ctx.beginPath()
      //   this.ctx.lineWidth = 1
      //   this.ctx.strokeStyle = 'rgba(255,255,255,0.5)'
      //
      //   this.ctx.moveTo(-this.windowWitdh / 2, 0)
      //   this.ctx.lineTo(this.windowWitdh / 2, 0)
      //
      //   this.ctx.moveTo(0, -this.windowHeight / 2)
      //   this.ctx.lineTo(0, this.windowHeight / 2)
      //   this.ctx.stroke()
      // }

      // 座標 校正用
      // coordinate()

      // 儀表板

      if (this.light === true) {
        this.ctx.shadowColor = '#999'
        this.ctx.shadowBlur = 20
        this.ctx.shadowOffsetX = 5
        this.ctx.shadowOffsetY = 5
      } else {
        this.ctx.shadowColor = null
        this.ctx.shadowBlur = null
        this.ctx.shadowOffsetX = 0
        this.ctx.shadowOffsetY = 0
      }

      // 內圈
      // this.ctx.save()
      // this.ctx.beginPath()
      // this.ctx.fillStyle = '#555'
      // this.ctx.arc(0, 0, 130, 0, Math.PI * 2, true)
      // this.ctx.fill()

      // 單位
      // this.ctx.fillStyle = 'rgba(255,255,255,1)'
      // this.ctx.textAlign = 'center'
      // this.ctx.font = '20px Arial'
      // this.ctx.fillText('摄氏度', 0, -50)
      // this.ctx.restore()

      // 中心圈圈
      // this.ctx.beginPath()
      // var grd = this.ctx.createRadialGradient(0, 0, 100, 0, 0, 1)
      // grd.addColorStop(0, 'white')
      // grd.addColorStop(1, 'black')
      // this.ctx.fillStyle = grd
      // this.ctx.arc(0, 0, 20, 0, Math.PI * 2, true)
      // this.ctx.fill()

      // 儀表板外框 135度~405度
      var degreeNum = 71
      var radius = 350
      var len

      for (var i = 0; i < degreeNum; i++) {
        this.ctx.beginPath()

        this.ctx.strokeStyle = '#BDC6CB'
        if (i % 5 === 0) {
          this.ctx.lineWidth = 3
          len = 30
        } else {
          this.ctx.lineWidth = 1
          len = 15
        }
        let angle = i * (270 / degreeNum) + 135
        if (angle <= speed) {
          this.ctx.strokeStyle = '#4CCB6B'
        } else if (speed < 135 && i === 0) {
          this.ctx.strokeStyle = '#4CCB6B'
        }
        let startPoint = this.point(radius - len, angle)
        let endPoint = this.point(radius, angle)
        this.ctx.moveTo(startPoint.x, startPoint.y)
        this.ctx.lineTo(endPoint.x, endPoint.y)

        if (i % 10 === 0) {
          this.ctx.fillStyle = '#BDC6CB'
          if (angle <= speed) {
            this.ctx.fillStyle = '#4CCB6B'
          } else if (speed < 135 && i === 0) {
            this.ctx.fillStyle = '#4CCB6B'
          }
          this.ctx.textAlign = 'center'
          this.ctx.font = '26px Arial'
          let numPoint = this.point(radius - 65, angle)
          this.ctx.fillText(16 + (i / 10) * 2, numPoint.x, numPoint.y)
        }
        this.ctx.stroke()
      }

      // 指針

      // let firstPoint = this.point(50, speed + 310)
      // let secondPoint = this.point(250, speed + 135)
      // let thirdPoint = this.point(50, speed + 320)
      // this.ctx.beginPath()
      // this.ctx.fillStyle = 'red'
      // this.ctx.moveTo(firstPoint.x, firstPoint.y)
      // this.ctx.lineTo(secondPoint.x, secondPoint.y)
      // this.ctx.lineTo(thirdPoint.x, thirdPoint.y)
      // this.ctx.fill()
    }
  }
}
</script>

<style scoped lang="less">
._touch {
  position: relative;
  text-align: center;
  > #canvas {
    width: 350px;
    height: 350px
  }
}
</style>
